import { css } from 'react-emotion';
import { colors, fonts } from '@peachjar/components';

const { prussian, gold, silver } = colors;
const { ProximaNova } = fonts;

export const styles = {
  wrapper: css`
    background-color: #f5f5f5;
    padding-top: 2rem;
    padding-bottom: 2rem;
    max-height: 1500px;
  `,
  header: css`
    font-size: 34px;
    color: ${prussian};
    font-weight: 600;
    margin-bottom: 2rem;
  `,
  innerWrapper: css`
    background-color: white;
    padding: 2rem;
    border-radius: 3px;
  `,
  headlineText: css`
    margin-left: 3px;
  `,
  row: css`
    padding-top: 2rem;
    padding-bottom: 5rem;
  `,
  item: css`
    border: 1px solid ${silver};
    padding: 1rem;
    margin-top: 2rem;
    border-radius: 3px;
    margin-right: 2rem;
  `,
  itemTitle: css`
    text-align: center;
    overflow-wrap: break-word;
    width: 230px;
  `,
  lineItem: css`
    font-size: 13px;
    font-family: ${ProximaNova};
    width: 24px;
    height: 24px;
    border: solid 2px ${gold};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.3rem;
  `,
  headline2: css`
    font-family: ${ProximaNova};
    font-size: 25px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.28;
    letter-spacing: normal;
    color: ${prussian};
    margin-bottom: 4px;
  `,
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff-training/containers/SetupStaffTrainingContainer.css.js